import axios from "axios";
import Swal from "sweetalert2";
import { api_urls } from "../api-urls";
import { access_token } from "../constant";

export const getAPI = async (url) => {
    const token = localStorage.getItem(access_token);

    const response = await axios.get(api_urls + url, { headers: { Authorization: 'Bearer ' + token } })
    return response;
};

export const postAPI = async (url, payload) => {
    const token = localStorage.getItem(access_token);

    const response = await axios.post(api_urls + url, payload, { headers: { Authorization: 'Bearer ' + token } });
    return response;
};

export const putAPI = async (url, payload) => {
    const token = localStorage.getItem(access_token);

    const response = await axios.put(api_urls + url, payload, { headers: { Authorization: 'Bearer ' + token } });
    return response;
};

export const patchAPI = async (url, payload) => {
    const token = localStorage.getItem(access_token);

    const response = await axios.patch(api_urls + url, payload, { headers: { Authorization: 'Bearer ' + token } });
    return response;
};

export const deleteAPI = async (url) => {
    const token = localStorage.getItem(access_token);

    const response = await axios.delete(api_urls + url, { headers: { Authorization: 'Bearer ' + token } });
    return response;
};

export const razorpayPayment = async ({ name, email, contact, image, amount = 0, currency, key_id, orderId }) => {
    try {
        let options = {
            key: key_id,
            name,
            currency,
            amount,
            order_id: orderId,
            prefill: { name, email, contact },
            theme: { color: '#05A08E' },
            description: `Your Amount : ${amount}`,
            image,
            config: {
                display: {
                    blocks: {
                        upi: {
                            name: "Pay via UPI",
                            instruments: [{ method: "upi" }]
                        },
                        card: {
                            name: "Pay via Card",
                            instruments: [{ method: "card" }]
                        },
                        netbanking: {
                            name: "Pay via Netbanking",
                            instruments: [{ method: "netbanking" }]
                        },
                        wallet: {
                            name: "Pay via Wallet",
                            instruments: [{ method: "wallet" }]
                        }
                    },
                    sequence: ["upi", "card", "netbanking", "wallet"], // order of options
                    preferences: {
                        show_default_blocks: false // disable EMI, PayLater, etc.
                    }
                }
            }
        };
        console.log("Razor Pay Option ::: ", options);

        return new Promise((resolve, reject) => {
            options.handler = function (response) {
                console.log('Handler Response ::: ', response);
                resolve({ status: true, message: 'Payment was successful.', result: response });
            };

            options.modal = {
                ondismiss: function () {
                    console.log("Payment Dismissed !!! ");
                    resolve({ status: false, message: 'Payment was dismissed by the user.', result: null });
                }
            };

            const razorpay = new window.Razorpay(options);
            razorpay.on('payment.failed', function (response) {
                console.log("Payment Failed !!! ", response?.error);
                reject({ status: false, message: response?.error?.description, result: response?.error });
            });
            razorpay.open();
        });

    } catch (error) {
        return { status: false, message: error?.response?.data?.message, result: null };
    }
};

// downloadPDF(`api/report/get-reports`);
export const downloadPDF = async (route, payload) => {
    try {
        // const response = await axios.get(
        //     api_urls + route,
        //     {
        //         responseType: 'blob', //* Important to receive binary data
        //         headers: { Accept: 'application/pdf', },
        //         validateStatus: function (status) {
        //             return status >= 200 && status < 500; //* Allow 4xx responses for custom handling
        //         },
        //     }
        // );
        const response = await axios.post(
            api_urls + route,
            payload,
            {
                responseType: 'blob',
                headers: { Accept: 'application/pdf' },
                validateStatus: status => status >= 200 && status < 500,
            }
        );

        const contentType = response.headers['content-type'];
        // 🔍 If error response in JSON (like 404)
        if (contentType && contentType.includes('application/json')) {
            const reader = new FileReader();
            reader.onload = () => {
                const errorData = JSON.parse(reader.result);
                Swal.fire({ icon: 'info', text: errorData.message || 'PDF not found.', showConfirmButton: false });
            };
            reader.readAsText(response.data);
            return;
        }

        // ✅ Extract exact filename from Content-Disposition
        const disposition = response.headers['content-disposition'];
        let filename = 'Default-Bill.pdf';
        if (disposition) {
            const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/);
            if (match) {
                filename = decodeURIComponent(match[1] || match[2]);
            }
        }

        // 📥 Trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();

        // ♻️ Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        Swal.fire({ icon: 'success', text: "Generated successfully.", showConfirmButton: false });
    } catch (error) {
        console.log("Generating PDF Error :::", error);
        Swal.fire({ icon: 'error', text: error?.response?.data?.message || 'Error while generating pdf.', showConfirmButton: false });
    }
};